//surface id query, gets canvas and manifestation
export const getAuthorInformation = (authorid: string) =>{
  const query = [
    "PREFIX dc: <http://purl.org/dc/elements/1.1/>",
    "CONSTRUCT",
    "{",
    "?author dc:title ?authorTitle ;",
    "<http://scta.info/property/hasTopLevelExpression> ?expression ;",
    "<http://scta.info/property/authorArticle> ?authorArticle;",
    "<http://scta.info/property/textArticle> ?textArticle .",
    "?authorArticle dc:title ?authorArticleTitle . ",
    "?textArticle dc:title ?textArticleTitle . ",
    "?expression dc:title ?topLevelExpressionTitle .",
    "}",
    "WHERE ",
    "{",
    "BIND(<" + authorid + "> as ?author) . ",
    "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
    "OPTIONAL",
    "{",
    "?expression <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?expression a <http://scta.info/resource/expression> .",
    "?expression <http://scta.info/property/level> '1' .",
    "?expression <http://purl.org/dc/elements/1.1/title> ?topLevelExpressionTitle .",
    "}",
    "OPTIONAL",
    "{",
    "?expression2 <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?textArticle <http://scta.info/property/isArticleOf> ?expression2 .",
    "?textArticle <http://purl.org/dc/elements/1.1/title> ?textArticleTitle .",
    "}",
    "OPTIONAL",
    "{",
    "?authorArticle <http://scta.info/property/isArticleOf> ?author .",
    "?authorArticle <http://purl.org/dc/elements/1.1/title> ?authorArticleTitle",
    "}",
    "}"].join('');
    return query
}